var map = {
	"./Anterior_Segmant_Assessmant_Tool_Patients_Record.pdf": "8538",
	"./CBD.pdf": "30b6",
	"./Ocular_Trauma_Score.pdf": "ce8e",
	"./Presentations_Lectures_Teachings.pdf": "61b6",
	"./Reports.pdf": "a6be",
	"./SOP_-SUBJECTIVE_REFRACTION_FORM-2021-2022.pdf": "605f",
	"./SOP_FOR_OBJECTIVE_REFRACTION_2021-2022.pdf": "c9aa",
	"./Surgical_Practical_Skills.pdf": "f5db",
	"./Trauma_1_BETTS.pdf": "2b5f",
	"./Trauma_2_World_Eye_Injury_Initial_Report.pdf": "d930",
	"./Trauma_3_World_Eye_Injury_Follow-Up_Form.pdf": "ef0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8629";